import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import ArticleCard from '@/components/base/ArticleCard';
import CategoryTabs from '@/components/base/CategoryTabs';
import Breadcrumb from '@/components/base/Breadcrumb';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === slug);
  const filteredArticles = slug
    ? articles.filter((a) => a.categorySlug === slug)
    : articles;

  const categoryName = currentCategory?.name || '全部文章';
  const displayArticles = filteredArticles.length > 0 ? filteredArticles : articles;

  return (
    <>
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${categoryName} - 草榴社区入口导航`,
          description: currentCategory?.description || '浏览草榴社区入口相关文章',
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: `${typeof window !== 'undefined' ? window.location.origin : ''}/` },
              { '@type': 'ListItem', position: 2, name: categoryName },
            ],
          },
        }}
      />

      <Navbar />

      <main className="min-h-screen pt-16">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="py-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: categoryName },
              ]}
            />
          </div>

          <div className="pb-8">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              {categoryName}
            </h1>
            {currentCategory && (
              <p className="text-sm text-foreground-500 mb-6">{currentCategory.description}</p>
            )}
            <CategoryTabs activeSlug={slug} />
          </div>

          <div className="pb-14 md:pb-20">
            {displayArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {displayArticles.map((article) => (
                  <ArticleCard key={article.id} {...article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-background-100 rounded-full">
                  <i className="ri-inbox-line text-2xl text-foreground-300"></i>
                </div>
                <p className="text-foreground-500">该分类下暂无文章</p>
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}